<template>
  <div class="c-main">
    <h2 class="c-title c-title--page">{{ $t('event.edit') }}</h2>
    <event :id="$route.params.eventId" @submit="update($event)" @remove="remove($event)">
    </event>
  </div>
</template>

<script>
import config from 'client/config';

export default {
  components: {
    event: require('./event.vue').default,
  },
  computed: {
    event: function () {
      return this.$store.state.events.current
    },
  },
  methods: {
    update: function (event) {
      this.$notify.saveAsync(
        this.$t('event'),
        this.$http.patch(config.root + '/events/' + event.id, event)
      );
    },
    remove: function (id) {
      this.$notify.removeAsync(
        this.$t('event'),
        this.$http.delete(config.root + '/events/' + id),
        () => {
          const home = this.$store.state.user.homepage
          this.$navigation.goto({name: home})
        }
      );
    }
  },
};
</script>

<style>
</style>
